/**
 * 국가 코드 → 국기 자산 코드. `react-flagpack` 은 `<img src="/flags/l/${code}.svg">` 만 그리므로
 * 코드와 파일 이름이 다른 나라는 여기서 바꾼다.
 *
 * ```
 *   GB → GB-UKM   자산이 구성국별(GB-ENG · GB-SCT …)로 나뉘어 있다
 *   BQ → NL       네덜란드령 카리브(보네르·신트외스타티위스·사바)는 공식적으로 네덜란드 국기를
 *                 쓴다. 자산엔 섬별(BQ-BO · BQ-SA · BQ-SE)만 있고 `BQ.svg` 가 없다 (#5842 R1)
 * ```
 *
 * 컴포넌트(`CountryFlag`)와 분리한 이유: 컴포넌트는 ESM 전용 `react-flagpack` 을 끌고 와 jest 가
 * 못 읽는다. 목록의 모든 코드에 자산이 있는지는 `__tests__/libs/countries` 가드가 **이 함수로** 잠근다.
 */
const FLAG_ASSET_CODE: Readonly<Record<string, string>> = {
  GB: "GB-UKM",
  BQ: "NL",
};

export function flagAssetCode(countryCode: string | null): string | null {
  if (!countryCode) return countryCode;
  return FLAG_ASSET_CODE[countryCode] ?? countryCode;
}
